export default "__VITE_ASSET__BxovJf2N__"